import { render, staticRenderFns } from "./chartTab.vue?vue&type=template&id=2790b7da&scoped=true&"
import script from "./chartTab.vue?vue&type=script&lang=js&"
export * from "./chartTab.vue?vue&type=script&lang=js&"
import style0 from "./chartTab.vue?vue&type=style&index=0&id=2790b7da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2790b7da",
  null
  
)

export default component.exports